<template>
  <div :class="`energy-demand__${nutrient}`">
    <Tooltip v-if="tooltip" placement="top">
      <template #trigger> <div class="energy-demand__header">{{ label }}</div> </template>
      {{ tooltip }}
    </Tooltip>
    <div v-else class="energy-demand__header">{{ label }}</div>
    <div class="energy-demand__info">
      <div class="energy-demand__info-left">
        {{ mode === 'sport' ? `${percentage} %` : `${grams} g` }}
      </div>
      <div v-if="mode === 'sport'" class="energy-demand__info-right">{{ grams }} g</div>
    </div>
    <div class="energy-demand__box">
      <div class="energy-demand__box-left">
        <BaseSlider
          :test-id="`DietDetailAssumptions__${nutrient}`"
          :min="0"
          :max="100"
          :color="color"
          :model-value="percentage"
          :readonly="mode === 'sport'"
          @update:model-value="mode === 'standard' && emit('update', $event)"
        />
      </div>
      <div class="energy-demand__box-right">
        <BaseInputNumber
          :test-id="`DietDetailAssumptions__${nutrient}`"
          :precision="mode === 'sport' ? 1 : undefined"
          :step="mode === 'sport' ? 0.1 : undefined"
          class="energy-demand__input"
          :model-value="inputValue"
          @update:model-value="emit('update', $event)"
        />
        {{ mode === 'sport' ? 'g/kg mc' : '%' }}
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import BaseInputNumber from '@/components/BaseInputNumber.vue'
  import BaseSlider from '@/components/BaseSlider.vue'
  import { Tooltip } from '@/components/ui'

  defineProps<{
    color: string
    grams: number
    inputValue: number
    label: string
    mode: 'sport' | 'standard'
    nutrient: string
    percentage: number
    tooltip?: string
  }>()
  const emit = defineEmits<{ update: [value: number] }>()
</script>
